/**
 * OrbDocReferenceOperatorsValidateAROrbDocReferenceOperatorsValidateARPage
 *
 * Page component for OrbDocReferenceOperatorsValidateAROrbDocReferenceOperatorsValidateARPage
 * Path: /ar/docs/reference/operators/validate
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocReferenceOperatorsValidateARDocScreenView as __OrbDocReferenceOperatorsValidateARDocScreenView } from '@/components/traits/OrbDocReferenceOperatorsValidateARDocScreenView';
import { OrbDocReferenceOperatorsValidateARDocAnalyticsView as __OrbDocReferenceOperatorsValidateARDocAnalyticsView } from '@/components/traits/OrbDocReferenceOperatorsValidateARDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocReferenceOperatorsValidateAROrbDocReferenceOperatorsValidateARPageProps {
  // Add any page-level props here
}

export function OrbDocReferenceOperatorsValidateAROrbDocReferenceOperatorsValidateARPage(_props: OrbDocReferenceOperatorsValidateAROrbDocReferenceOperatorsValidateARPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"التحقق","description":"كل عامل يستطيع برنامج .lolo استدعاءه، من السجل المعتمد الذي يضمّنه المترجم.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/reference/operators/validate"},{"locale":"ar","path":"/ar/docs/reference/operators/validate"},{"locale":"sl","path":"/sl/docs/reference/operators/validate"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocReferenceOperatorsValidateARDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocReferenceOperatorsValidateARDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocReferenceOperatorsValidateAROrbDocReferenceOperatorsValidateARPage;
